"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobile = void 0;
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
const useIsMobile = () => {
  const {
    width
  } = (0, _presentationHooks.useWindowSize)();
  const {
    breakpoints
  } = (0, _mui.useTheme)();
  return width !== 0 && width < breakpoints.values.md;
};
exports.useIsMobile = useIsMobile;